// extracted by mini-css-extract-plugin
export default {"input":"TextareaInput_input__zlRYH"};